/**
 * 组件库
 * element 官方文档: https://element.eleme.cn/#/zh-CN/component
 */
import Vue from 'vue';
import ElementUI from 'element-ui';

Vue.use(ElementUI);
